import {useRef} from "react";
import {useParams} from "react-router";
import {css} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {mb, onDesktop} from "@pg-design/helpers-css";
import {IRankingAnnualParams} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetRegionDetailListBySlugQuery} from "../../../region/api/get_region_detail_list_by_slug";
import {AnnualRankingLinks} from "../AnnualRankingLinks";
import {LocationRankingDescription} from "../LocationRankingDescription";
import {OfferRankingBreadcrumbs} from "../offer_ranking/OfferRankingBreadcrumbs";
import {OfferRankingForm} from "../offer_ranking_form/OfferRankingForm";
import {OfferRankingPanel} from "../OfferRankingPanel";
import {RankingCreationSteps} from "./ranking_creation_steps/RankingCreationSteps";
import {RankingCreationSteps2023} from "./ranking_creation_steps/RankingCreationSteps2023";
import {ArchiveRankingList} from "./ArchiveRankingList";
import {RankingListBanner} from "./RankingListBanner";

export function ArchiveRanking() {
    const params = useParams<IRankingAnnualParams>();
    const {data: regionResponse} = useGetRegionDetailListBySlugQuery({slug: params.citySlug});

    const region = regionResponse ? regionResponse.results[0] : null;
    const {isMobile} = useUserDevice();
    const creationStepsRef = useRef<HTMLDivElement>(null);

    const handleGetMoreInfoClick = () => {
        if (creationStepsRef.current) {
            creationStepsRef.current.scrollIntoView({behavior: "smooth"});
        }
    };

    return (
        <article>
            <WideContent>
                <OfferRankingBreadcrumbs />
                {!isMobile && <OfferRankingForm horizontal />}
                {isMobile && <OfferRankingPanel />}
                {region && (
                    <>
                        <RankingListBanner handleGetMoreInfoClick={handleGetMoreInfoClick} name_declension_where={region.name_declension_where} />
                        <section css={mb(9)}>
                            <ArchiveRankingList currentRegion={region} year={params.year} />
                        </section>
                        {params.year === "2022" ? (
                            <RankingCreationSteps css={creationSteps} scrollRefElem={creationStepsRef} />
                        ) : (
                            <RankingCreationSteps2023 scrollRefElem={creationStepsRef} />
                        )}
                        <LocationRankingDescription currentRegion={region} />
                    </>
                )}
                <AnnualRankingLinks />
            </WideContent>
        </article>
    );
}

// Styles
const creationSteps = css`
    ${mb(9)}

    ${onDesktop(css`
        ${mb(15)}
    `)}
`;
